module.exports = __webpack_public_path__ + "static/media/Sample-Listening-Plan-Map-Diagram-Labelling-Type-A-trimmed.3467f403.mp3";